import React, { useState, useContext } from 'react'
// import MonsterWindow from './components/MonsterWindow/MonsterWindow'
// import Saves from './components/Saves/Saves'
// import Other from './components/Other/Other'
import Header from './components/Header/Header'
import Menu from './components/Menu/Menu'
// import Cards from './components/Cards/Cards'
// import $ from 'jquery'

import { CharacterProvider } from './contexts/character'
import { SubStatsProvider } from './contexts/subStats'
import { DBProvider } from './contexts/databases'

import { UIContext } from './contexts/ui'

import './app.scss'
import './sb-admin-2.css'
import CharWindow from './components/CharWindow/CharWindow'
// import SubStats from './components/SubStats/SubStats'
import ExtendedInfo from './components/ExtendedInfo/ExtendedInfo'
// import EquipementTab from './components/EquipmentTab/EquipementTab'
import EquipementTabModal from './components/EquipmentTabModal/EquipementTabModal'
import ItemDescription from './components/ItemDescription/ItemDescription'
// import MonsterWindow from './components/MonsterWindow/MonsterWindow'
import SkillTree from './components/SkillTree/SkillTree'
import BattleTab from './components/BattleTab/BattleTab'
// import YMLToJSON from './components/YMLToJSON/YMLToJSON'
//only for test all the items scripts
// import Tests from './components/Tests/Tests'

function App(props) {
	let currentLanguage = 'en'
	const [activeWindow, setActiveWindow] = useState(Number(1))
	const [lastSelectedItem, setLastSelectedItem] = useState(Number(0))
	const { Theme } = useContext(UIContext)
	function handleClick(e) {
		setActiveWindow(Number(e.target.value))
	}
	return (
		<div className='mainContainer'>
			<DBProvider>
				<CharacterProvider>
					<SubStatsProvider>
						<Menu />
						{/* <Saves /> */}
						<div className={'mainPage mainBGColor' + Theme}>
							<Header />
							<div className='mainBody'>
								<div className='CharWinAndInfo'>
									{/* <Cards Name={'Stats'}> */}
									<CharWindow
										currentLanguage={currentLanguage}
									/>
									{/* </Cards> */}
									{/* <SubStats /> */}
									<ExtendedInfo />
								</div>
								<div className='buttons'>
									<button onClick={handleClick} value={1}>
										Gears
									</button>
									<button onClick={handleClick} value={2}>
										Skills
									</button>
									{/*	<button onClick={handleClick} value={3}>
										Monsters
									</button>*/}
								</div>
								<div
									className={
										'MainBody'
										// + (activeWindow === 1? ' active': ' inactive')
									}
								>
									{/* <EquipementTab
									currentLanguage={currentLanguage}
								/> */}
									<div className='EquipAndSkills'>
										<EquipementTabModal
											currentLanguage={currentLanguage}
											lastSelectedItem={lastSelectedItem}
											setLastSelectedItem={
												setLastSelectedItem
											}
											className={
												activeWindow === 1
													? ' active'
													: ' inactive'
											}
										/>
										<SkillTree
											className={
												activeWindow === 2
													? ' active'
													: ' inactive'
											}
										/>
									</div>
									<div className='descAndBattle'>
										<ItemDescription
											lastSelectedItem={lastSelectedItem}
										/>
										<BattleTab />
									</div>
									{/* <SkillTree
									className={
										activeWindow === 2
											? ' active'
											: ' active'
									}
								/>
								<BattleTab
									className={
										// activeWindow === 3 ? ' active' : ' inactive'
										activeWindow === 3
											? ' active'
											: ' active'
									}
								/> */}
								</div>
							</div>

							{/* only for test all the items scripts */}
							{/* <Tests /> */}
							{/* only for converting yaml file to JSON */}
							{/* <YMLToJSON /> */}
							{/* <BattleTab
							// className={
							// 	activeWindow === 3 ? ' active' : ' inactive'
							// }
							/> */}
							{/* <MonsterWindow
							className={
								activeWindow === 3 ? ' active' : ' inactive'
							}
						/> */}
							{/* <Other /> */}
						</div>
					</SubStatsProvider>
				</CharacterProvider>
			</DBProvider>
		</div>
	)
}

export default App
